export default function getTimeFromISO(string) {
  let date = new Date(string);

  var h = date.getUTCHours() % 12 || 12;
  var ampm = date.getUTCHours() < 12 || date.getUTCHours() === 24 ? "AM" : "PM";
  // return adjusted time or original string

  return `${h}:${date.getUTCMinutes()} ${ampm}`;
}
